import { render, staticRenderFns } from "./CasebackEngraving.vue?vue&type=template&id=1891f8f1&"
import script from "./CasebackEngraving.vue?vue&type=script&lang=js&"
export * from "./CasebackEngraving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports